import type { FC } from 'react';
import { Modal, Button } from '@/uicomponents';
import { ErrorPanel } from '@/components/shared';

export interface ConflictModalProps {
  open: boolean;
  onReloadLatest: () => void;
  onKeepMyChanges: () => void;
}

export const ConflictModal: FC<ConflictModalProps> = ({
  open,
  onReloadLatest,
  onKeepMyChanges,
}) => {
  return (
    <Modal
      width='var(--dz-modal-sm)'
      open={open}
      closable={false}
      maskClosable={false}
      title='This Request Was Updated Elsewhere'
      footer={[
        <Button key='reload' onClick={onReloadLatest}>
          Reload Latest
        </Button>,
        <Button key='keep' type='primary' onClick={onKeepMyChanges}>
          Keep My Changes
        </Button>,
      ]}
    >
      <ErrorPanel title='Conflict detected'>
        Someone opened this draft in another tab or device and saved changes. Pick how to continue.
      </ErrorPanel>
    </Modal>
  );
};
